import ParentHeader from "@/components/common/ParentHeader";
import HolidaysView from "@/components/holidays";

export default function ParentHolidays() {
  return (
    <div className="min-h-screen bg-gray-50">
      <ParentHeader />
      <main className="max-w-7xl mx-auto px-4 sm:px-6 py-6 sm:py-8">
        <HolidaysView viewOnly />
      </main>
    </div>
  );
}
